import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { MatButtonModule } from '@angular/material/button';
import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatBadgeModule } from '@angular/material/badge';
import {OfficeCommunicationComponent} from './office-communication.component';

@NgModule({
    declarations: [
        OfficeCommunicationComponent,
    ],
    imports: [
        CommonModule,
        FormsModule,
        MatButtonModule,
        MatInputModule,
        MatFormFieldModule,
        MatBadgeModule,
    ],
    exports: [
        OfficeCommunicationComponent,
    ],
    schemas: [ CUSTOM_ELEMENTS_SCHEMA ]
})
export class OfficeCommunicationModule { }
